export default "__VITE_ASSET__DbJ7O76z__"